import { httpResponseHandler } from 'src/http/http-response-handler';

import { HttpTypes } from '../../http';

export class AuthRepository {
  constructor(private api: HttpTypes.HttpClient) { }

  async authLogin(cpf: string, BUId: string, eventId: string) {
    const params: any = { BUId, eventId }
    const request: HttpTypes.HttpRequest = {
      url: 'auth/login-lp-events-user',
      method: 'post',
      body: {
        cpf,
      },
      params,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async authRegister(cpf: string, name: string, email: string, phone: string, BUId: string, eventId: string, lpEventsLocation?: { region?: string, uf?: string, city?: string }) {
    const params: any = { BUId, eventId }
    const request: HttpTypes.HttpRequest = {
      url: 'auth/create-lp-events-user',
      method: 'post',
      body: {
        cpf,
        name,
        email,
        phone,
        ...lpEventsLocation
      },
      params
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async verifyEventAccess(BUId: string, eventId: string) {
    const params = { BUId, eventId } as any
    const request: HttpTypes.HttpRequest = {
      url: 'auth/verify-lp-event-user-by-token',
      method: 'get',
      params,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async getStates() {
    const request: HttpTypes.HttpRequest = {
      url: 'auth/ufs',
      method: 'get',
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async getCities(uf: string) {
    const request: HttpTypes.HttpRequest = {
      url: `auth/cities/${uf}`,
      method: 'get',
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async getRegions() {
    const request: HttpTypes.HttpRequest = {
      url: `auth/regions`,
      method: 'get',
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }
}
